import { Component, Vue } from 'vue-property-decorator';

@Component
export default class IsNotificationsCheckMixin extends Vue {
  get isNotificationsModule() {
    return !!this.$store.getters.hasApiModuleNotifications;
  }
}



// WEBPACK FOOTER //
// ./src/mixins/isNotificationsCheck.ts